import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "white--text"
}
const _hoisted_3 = {
  key: 1,
  class: "calendar-nav-btn__label"
}
const _hoisted_4 = { class: "d-flex justify-center align-center" }
const _hoisted_5 = { class: "calendar-nav-btn__label" }
const _hoisted_6 = { class: "pa-7" }
const _hoisted_7 = { class: "caption" }
const _hoisted_8 = { class: "text-no-wrap" }
const _hoisted_9 = { class: "plan-content" }
const _hoisted_10 = { class: "event-name" }
const _hoisted_11 = { class: "children-wrap" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      tile: "",
      class: "overflow-hidden no-scroll-bar",
      elevation: "0",
      style: {"background-color":"transparent"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar, {
          class: "app_bar",
          fixed: "",
          color: "primary",
          dark: "",
          "scroll-target": "#scrolling-techniques-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _ctx.toPrevMonth,
              icon: _ctx.locale === 'ja',
              variant: _ctx.isEnglishOrKhmer ? 'text' : undefined,
              class: _normalizeClass(["no-background-hover", _ctx.isEnglishOrKhmer ? 'calendar-nav-btn px-0 custom-v-btn' : '']),
              color: "white",
              dark: _ctx.locale === 'ja'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["d-flex align-center", _ctx.isEnglishOrKhmer ? 'calendar-nav-btn__inner' : ''])
                }, [
                  _createVNode(_component_v_icon, {
                    size: "20",
                    class: _normalizeClass(_ctx.isEnglishOrKhmer ? 'calendar-nav-btn__icon' : _ctx.locale === 'ja' ? 'ml-4' : '')
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.locale === 'ja')
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_2, "前の月"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.translate('calendar.prevMonth')), 1))
                ], 2)
              ]),
              _: 1
            }, 8, ["onClick", "icon", "variant", "class", "dark"]),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_app_bar_title, {
              class: _normalizeClass(_ctx.isEnglishOrKhmer ? 'calendar-app-bar-title' : '')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "calendar-header-title-block",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCalendar = !_ctx.isCalendar))
                }, [
                  _createElementVNode("h5", {
                    class: _normalizeClass(["text-center", _ctx.isEnglishOrKhmer ? 'calendar-header-year' : ''])
                  }, _toDisplayString(_ctx.locale === 'ja' ? _ctx.year + '年' : _ctx.year), 3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.month), 1),
                    (_ctx.isCalendar)
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-chevron-down", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-chevron-up", -1)
                          ]))]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              onClick: _ctx.toNextMonth,
              icon: _ctx.locale === 'ja',
              variant: _ctx.isEnglishOrKhmer ? 'text' : undefined,
              class: _normalizeClass(["no-background-hover", _ctx.isEnglishOrKhmer ? 'calendar-nav-btn px-0 custom-v-btn' : '']),
              color: "white"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["d-flex align-center", _ctx.isEnglishOrKhmer ? 'calendar-nav-btn__inner' : ''])
                }, [
                  (_ctx.locale === 'ja')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "white--text" }, "次の月", -1)),
                        _createVNode(_component_v_icon, {
                          size: "20",
                          class: "mr-4"
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate('calendar.nextMonth')), 1),
                        _createVNode(_component_v_icon, {
                          size: "20",
                          class: "calendar-nav-btn__icon"
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ], 64))
                ], 2)
              ]),
              _: 1
            }, 8, ["onClick", "icon", "variant", "class"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_expand_transition, null, {
          default: _withCtx(() => [
            (_ctx.isCalendar)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  class: "mt-8",
                  height: "400",
                  style: {"background-color":"transparent"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_calendar, {
                      ref: "event_calendar",
                      now: _ctx.now,
                      modelValue: _ctx.selectedDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                      color: "primary",
                      locale: _ctx.vCalendarLocale,
                      "weekday-format": _ctx.calendarWeekdayLabel,
                      "day-format": _ctx.calendarDayLabelSecondPart,
                      "month-format": timestamp => new Date(timestamp.date).getDate() + ' /',
                      "onClick:date": _ctx.viewDay
                    }, {
                      day: _withCtx(({ date }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventNum(date), (e) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: e.eventId,
                            class: "d-flex justify-center"
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("div", { class: "event_num ma-1" }, null, -1)
                          ]))]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["now", "modelValue", "locale", "weekday-format", "day-format", "month-format", "onClick:date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
          [_vShow, !_ctx.isCalendar]
        ]),
        _createVNode(_component_v_sheet, {
          id: "scrolling-techniques-2",
          class: "overflow-y-auto no-scroll-bar",
          style: {
          maxHeight: `calc(100vh - var(--app-top-offset) - 60px - 56px - env(safe-area-inset-bottom))`,
          paddingBottom: 'calc(56px + env(safe-area-inset-bottom))',
          backgroundColor: 'transparent'
        },
          elevation: "0"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: e + index,
                class: "plan-wrapper ma-1 pa-2 pr-3 d-flex"
              }, [
                _createElementVNode("div", {
                  class: "text-center pr-2",
                  style: _normalizeStyle(_ctx.isEnglishOrKhmer ? 'width: 50px;' : 'width: 40px;')
                }, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.dayFormat(e.date)), 1),
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.dateFormat(e.date)), 1)
                ], 4),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventNames(e.eventName), (name, nameIndex) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: nameIndex,
                        class: "event-name-item"
                      }, _toDisplayString(name), 1))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(e.children, (child) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: child.childId,
                        class: "icon"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.resolveChildImageUrl(child.imageUrl) || 'https://via.placeholder.com/240x180?text=Sample+Image+1'
                        }, null, 8, _hoisted_12)
                      ]))
                    }), 128))
                  ])
                ])
              ])), [
                [_directive_scroll, _ctx.onScroll, "#scrolling-techniques-2"]
              ])
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}